import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid } from '@material-ui/core';
import Button from 'on_web/components/shared/Common/Button';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ROUTE_ASSESSMENT_RECOMMENDATIONS } from 'routes';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import AssessmentSectionTitle from 'on_web/components/shared/AssessmentSectionTitle/AssessmentSectionTitle';

import { useHistory } from 'react-router-dom';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import { getRecommendation } from 'on_web/helpers/risksHelper';

export default function RiskRecommendationCard(props) {
  const history = useHistory();

  const useStyles = makeStyles(theme => ({
    title: {
      fontFamily: 'Museo-500',
      fontSize: 18,
      lineHeight: 1.19,
      color: '#2a343f',
      textTransform: 'uppercase',
      paddingTop: '20px',
      textAlign: 'center',
      paddingLeft: '20px',
    },
    uList: {
      paddingLeft: '20px',
      listStyle: props.isDesktop ? 'none' : 'disc',
    },
    tipsContainer: {
      fontFamily: 'Museo-500',
      fontSize: '12px',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
    sectionBullet: {
      marginTop: '8px',
      color: '#33B0CE',
    },
    sectionBulletContent: {
      color: '#222222',
      fontSize: props.isDesktop ? '16px' : '12px',
    },
  }));

  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <AssessmentSectionTitle
        isDesktop={props.isDesktop}
        title={t('reporting.myAssessment.recommendationsTitle')}
      />

      <Box
        style={{
          paddingLeft: '20px',
          paddingRight: '20px',
          paddingBottom: '20px',
          marginTop: '14px',
          marginBottom: '20px',
          borderBottom: '1px Solid #efefef',
        }}
      >
        <Grid
          container
          style={{ paddingTop: '17px' }}
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          <Grid item xs={12} md={6}>
            <Grid container>
              <Grid item xs={4}>
                <Box display="flex">
                  <img
                    alt="recommendation"
                    src={
                      getRecommendation(props.stateToTransfer.healthBasedRisks)
                        .image
                    }
                    width={100}
                  />
                </Box>
              </Grid>
              <Grid item xs={8}>
                <Typography
                  variant="h5"
                  style={{
                    fontSize: '18px',
                    color: getRecommendation(
                      props.stateToTransfer.healthBasedRisks
                    ).color,
                  }}
                >
                  {
                    getRecommendation(props.stateToTransfer.healthBasedRisks)
                      .text
                  }
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container direction="column">
              <Grid item>
                <Box className={classes.tipsContainer}>
                  <ul className={classes.uList}>
                    {getRecommendation(
                      props.stateToTransfer.healthBasedRisks
                    ).tips.map((tip, ix) => {
                      return (
                        <li key={ix} className={classes.sectionBullet}>
                          <span className={classes.sectionBulletContent}>
                            {tip}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="flex-start">
          <Button
            endIcon={<NavigateNextIcon />}
            variant="text"
            onClick={() => {
              trackEvent('Reporting', 'Learn more about Recommendations');
              history.push({
                pathname: ROUTE_ASSESSMENT_RECOMMENDATIONS,
                state: props.stateToTransfer,
              });
            }}
          >
            <Typography variant="h7">
              {t('reporting.myAssessment.learnMore')}
            </Typography>
          </Button>
        </Box>
      </Box>
    </>
  );
}

RiskRecommendationCard.propTypes = {};
